import { render, staticRenderFns } from "./HeaderUserBlock.vue?vue&type=template&id=2d588feb&scoped=true&"
import script from "./HeaderUserBlock.vue?vue&type=script&lang=js&"
export * from "./HeaderUserBlock.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUserBlock.vue?vue&type=style&index=0&id=2d588feb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d588feb",
  null
  
)

export default component.exports